const colors = {
  backgroundPrimary: "#FFFFFF",
  backgroundSecondary: "#EFEEEB",
  backgroundSurfacePrimary: "#F6F6F6",
  backgroundSurfaceSecondary: "#F3F3F3",
  backgroundTintPrimary: "#FAFAFA",
  backgroundTintSecondary: "#F1F3F6",
  textPrimary: "#000000",
  textSecondary: "#727272",
  textMuted: "#818181",
  border: "#CDCDCD",
  black: "#000000",
  dash: "#E8E8E8",
};
export default colors;
